import s from './spinner.module.css';

class SpinnerController {
  constructor() {
    this.s = s;
  }
}

export default SpinnerController;
